import React from 'react';
import { Link } from 'react-router-dom';
import ScrollToTopButton from './ScrollToTop';
import PrimaryButton from './PrimaryButton';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='footer'>
      <div className='footer__panel'>
        <div className='footer__grid'>
          <div className='footer__brand'>
            <img
              className='footer__logo'
              src={process.env.PUBLIC_URL + '/images/jsp-logo.svg'}
              alt='J. Schuyler Sprowles'
            />
            <div className='footer__brand-copy'>
              <p className='footer__tagline'>
                Fiction rooted in faith, exile, and belonging.
              </p>
              <PrimaryButton
                as={Link}
                to='/writing'
                label='Explore Writing'
                tone='light'
              />
            </div>
          </div>
          <div className='footer__group'>
            <p className='footer__eyebrow'>Navigate</p>
            <Link className='footer__link' to='/'>
              Home
            </Link>
            <Link className='footer__link' to='/about'>
              About
            </Link>
            <Link className='footer__link' to='/writing'>
              Writing
            </Link>
            <Link className='footer__link' to='/contact'>
              Contact
            </Link>
          </div>
          <div className='footer__group'>
            <p className='footer__eyebrow'>Connect</p>
            <a className='footer__link' href='mailto:skysprowles@yahoo.com'>
              skysprowles@yahoo.com
            </a>
            <a
              className='footer__link'
              href='https://www.instagram.com/skysprowles/'
              target='_blank'
              rel='noreferrer'
            >
              Instagram
            </a>
            <a
              className='footer__link'
              href='https://www.facebook.com/schuylersprowlesauthor'
              target='_blank'
              rel='noreferrer'
            >
              Facebook
            </a>
          </div>
        </div>
        <div className='footer__meta'>
          <p className='footer__meta-copy'>Fiction inspired by the Gospels</p>
          <p className='footer__meta-copy footer__meta-copy--center'>
            &copy; {currentYear} J. Schuyler Sprowles. All rights reserved.
          </p>
          <a
            className='footer__meta-link'
            href='https://sethephur.com'
            target='_blank'
            rel='noreferrer'
          >
            Code by Seth
          </a>
        </div>
        <ScrollToTopButton />
      </div>
    </footer>
  );
};

export default Footer;
